export default {
      id: "weather-mostly-cloudy-moon-usage",
      viewBox: "0 0 449.6 369.5",
      url: "../images" + "/icons.svg#weather-mostly-cloudy-moon",
      toString: function () {
        return this.url;
      }
    }